import { Add } from "@carbon/icons-react";
import cx from "classnames";
import { useRouter } from "next/router";
import { type FC, useCallback, useState } from "react";

import { LoadingSpinner } from "@moment/design-system/LoadingSpinner";

import { useDocumentActor } from "~/state";

import { useEasel } from "../easel";
import { useCurrentDocument } from "../hooks/useCurrentDocument";

export const NewPageButton: FC = () => {
	const router = useRouter();

	const { workspaceName } = useEasel();
	const currentDocument = useCurrentDocument();
	const document = useDocumentActor(currentDocument?.id ?? "");

	const [isDisabled, setIsDisabled] = useState(false);

	const createPage = useCallback(() => {
		setIsDisabled(true);

		const subscription = document?.on("page.added", (event) => {
			const pageMetadata = event.payload.pageMetadata;

			setIsDisabled(false);

			subscription?.unsubscribe();

			void router.push(`/d/${workspaceName}/${currentDocument!.id}/${pageMetadata.slug}`);
		});

		document?.send({
			type: "page.added",
		});
	}, [document, router, workspaceName, currentDocument]);

	return (
		/**
		 * TODO: we're using a bare button for now because we don't currently have
		 * a button component in the design system for a list of rows.
		 */
		<div className="flex flex-col items-stretch">
			<button
				className={cx(
					"hover:bg-tertiary ",
					"text-secondary",
					"hover:text-primary",
					"group",
					"m-0",
					"mx-2",
					"flex",
					"items-center",
					"rounded",
					"space-x-2",
					"border-none",
					"py-2",
					"pl-3",
					"pr-2",
					"text-sm",
					isDisabled && "text-tertiary",
					!isDisabled && "text-secondary hover:text-primary"
				)}
				onClick={createPage}
				disabled={isDisabled}
			>
				{isDisabled ? <LoadingSpinner /> : <Add />}
				<span>New Page</span>
			</button>
		</div>
	);
};
